import React from 'react';
import {
    Container
} from './styles'

const reload = () => {
    return window.location.reload()
}

function ErrorFallback({error}: any) {
    return (
        <Container>
            <p>Произошла ошибка! Обновите страницу и обратитесь к команде разработки</p>
            <div>Текст ошибки:</div>
            <pre>{error.message}</pre>
            <button onClick={reload}>Обновить страницу</button>
        </Container>
    )
}

export default ErrorFallback;
